
import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { routeACL, SCOPE,paths } from '../../portal.router.config'
import {getData,clearSession} from '../utils/common'
import LandingPage from '../pages/landing-page/LandingPage'
import { custom_page } from '../../portal.custom.page.config'
var LandingCompnent = custom_page.landing ? custom_page.landing : LandingPage;

function PrecheckRoute(props) {
    const { component, label, ...rest } = props;
    const session = getData();
    console.log("a      chẹck route session:",session);
    console.log("a      chẹck route props:", props);
    let Component = component;
    const location = rest.location.pathname;
    var redirectPath = null;
    if (!session) {
        clearSession();
        Component = LandingCompnent;
    }
    if (location !== paths.home) {
        redirectPath = getRedirectPath(location);
    }

    return (
        <Route
            {...rest}
            render={routeProps =>
                !redirectPath ? (<Component {...routeProps} rootProps={props.rootProps}/>) :
                    (<Redirect
                        to={{
                            pathname: redirectPath,
                            state: { from: location }
                        }}
                    />
                    )
            }
        />
    );
}

function getRedirectPath(location) {
    const session = getData();
    const acl = routeACL[location];
    if (!acl)
        return null;
    if (!getData()) { // no session
        console.log('XXXXX: no Session')
        if (isSessionRequired(acl))
            return paths.home;
        else
            return null;
    }
    if (!session)
        return paths.home;
    if (isSessionRequired(acl) === false)
        return null;
}

function isSessionRequired(acl) {
    return acl === SCOPE._IN_SESSION;
}

export default PrecheckRoute;


